import { ActivatedRouteSnapshot } from '@angular/router';

export function getDeepestRouteSnapshot(snapshot: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
  let route = snapshot;
  while (route.firstChild) {
    route = route.firstChild;
  }
  return route;
}
